import CONTENTO_TYPES from 'app/domain/ContentoTypes';

export const getProgress = (content, continueWatchingIsActive, continueWatchingItems) => {
    if (
        continueWatchingIsActive &&
        (content.item.__typename === CONTENTO_TYPES.EPISODE ||
            content.item.__typename === CONTENTO_TYPES.SINGLE ||
            content.item.__typename === CONTENTO_TYPES.VARIANT)
    ) {
        let position = 0;

        if (content.progressFraction) {
            return content.progressFraction;
        } else if (content.savedPosition) {
            position = content.savedPosition;
        } else {
            const savedItem = (continueWatchingItems ? continueWatchingItems : []).find(
                (item) => item.videoId && item.videoId.startsWith(content.item.id)
            );
            position = savedItem && savedItem.position ? savedItem.position : 0;
        }

        return content.materialLength > 0 ? (position / content.materialLength) * 100 : 0;
    }

    return 0;
};
